import { errorHandler } from '@/composables/errorHandler'
import { useCommonStore } from '@/stores'

export const createPrefetchGuard = ({ getId, fetch, loader = 'main', onMissingId, onError }) => {
    return async (to) => {
        const commonStore = useCommonStore()

        const toggleLoader = (value) => {
            if (loader === 'circular') {
                commonStore.toggleCircularLoader(value)
                return
            }

            commonStore.toggleMainLoader(value)
        }

        const id = String(getId?.(to) || '')
        if (!id) {
            return typeof onMissingId === 'function' ? onMissingId(to) : false
        }

        toggleLoader(true)
        try {
            await fetch?.(id, to)
            return true
        } catch (error) {
            errorHandler(error)
            // On failure, navigation may abort without afterEach — hide loader here.
            toggleLoader(false)
            return typeof onError === 'function' ? onError(error, to) : false
        }
        // Success: do not toggleLoader(false) here — router.afterEach runs only after async
        // route chunks are loaded; clearing early hid the gap between prefetch end and import()
        // (noticeable on slow 3G). Global afterEach turns off mainLoader and circularLoader.
    }
}
